// Copy the Product details table from the hidden data section into the accordion slot.
// Liquid cannot read another section's blocks, so the data section renders the table
// and this script places it inside the Product details accordion.

function fillProductDetailsSlots() {
  var source = document.querySelector('[data-product-details-source]');
  var slots = document.querySelectorAll('[data-product-details-slot]');
  var hasTable = source && source.querySelector('table');

  for (var i = 0; i < slots.length; i++) {
    var block = slots[i].closest('.product-info__block-item');

    if (!hasTable) {
      if (block) block.hidden = true;
      continue;
    }

    if (block) block.hidden = false;
    slots[i].innerHTML = source.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', fillProductDetailsSlots);
document.addEventListener('shopify:section:load', fillProductDetailsSlots);
fillProductDetailsSlots();
